import React, { Component, Fragment } from "react";
import ReactSelect from "react-select";

class Select extends Component {
  static defaultProps = {
    options: [],
    errors: null,
  };

  state = {
    options: this.props.options,
  };

  render() {
    const { options } = this.state;
    const { errors, className = "", disabled } = this.props;

    const styles = {
      option: (provided, state) => ({
        ...provided,
        backgroundColor:
          state.isSelected || state.isFocused ? "#6C0CAE" : "#FFF",
        color: state.isSelected || state.isFocused ? "#FFF" : "#333",
      }),

      multiValue: (provided) => ({
        ...provided,
        borderRadius: 100,
        backgroundColor: "#6C0CAE",
        color: "#FFF",
      }),

      multiValueLabel: (provided) => ({
        ...provided,
        color: "#FFF",
        fontSize: 12,
      }),

      multiValueRemove: (provided, state) => ({
        ...provided,
        borderTopRightRadius: 100,
        borderBottomRightRadius: 100,
        backgroundColor:
          state.isFocused || state.isSelected ? "#6C0CAE" : "#6C0CAE",
      }),
    };

    return (
      <Fragment>
        <ReactSelect
          options={options}
          styles={styles}
          isDisabled={disabled}
          classNamePrefix="form-select"
          {...this.props}
          className={`form-select ${className}`}
        />

        {errors !== null && <span className="helper">{errors.join(", ")}</span>}
      </Fragment>
    );
  }
}

export default Select;
